// Generated by scripts/build-spectral-tables.mjs — do not edit by hand.
// Grid: 360–830 nm in 5 nm steps (95 values).
//
// Extraterrestrial solar spectral irradiance at 1 AU, W m^-2 nm^-1: the ETR column of the
// ASTM G173-03 reference spectra (derived from SMARTS v2.9.2, Gueymard), distributed by the
// U.S. DOE National Laboratory of the Rockies (formerly NREL),
// https://www.nlr.gov/grid/solar-resource/spectra-am1.5 — free to use with credit to DOE/NLR.
// Each value is the box average over [λ − 2.5, λ + 2.5] nm.
export const SOLAR_IRRADIANCE_5NM: readonly number[] = [
  0.92909, 1.1507, 1.1946, 1.0526, 1.1893, 0.93393, 1.1739, 0.93824, 1.6258, 1.7064, 1.7116, 1.7606,
  1.7257, 1.7061, 1.4578, 1.743, 1.7696, 1.9107, 2.05, 2.012, 2.0379, 2.0089, 1.9975, 2.027, 2.0612,
  1.8822, 1.9184, 1.9748, 1.8998, 1.9343, 1.9353, 1.8076, 1.8139, 1.8463, 1.9275, 1.8693, 1.8366,
  1.8769, 1.8648, 1.858, 1.8177, 1.8328, 1.8308, 1.8518, 1.8287, 1.8359, 1.7533, 1.7913, 1.7543,
  1.7631, 1.731, 1.6786, 1.7034, 1.6651, 1.6609, 1.6447, 1.6303, 1.6121, 1.5769, 1.4844, 1.5511,
  1.5551, 1.5326, 1.5087, 1.4942, 1.4629, 1.471, 1.4454, 1.4178, 1.4154, 1.3942, 1.3674, 1.3429,
  1.3491, 1.3188, 1.32, 1.2775, 1.2902, 1.2742, 1.2691, 1.2543, 1.2339, 1.2153, 1.208, 1.1971,
  1.1869, 1.169, 1.1398, 1.1387, 1.1227, 1.1111, 1.111, 1.0742, 1.0734, 1.0603,
];
